import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  FORM_MAX_WIDTH,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {FormControl, IconButton, Typography} from "@material-ui/core";
import View from "src/js/components/commons/View";
import {FontWeightMedium} from "src/res/FontWeight";
import Space from "src/js/components/commons/Space";
import {GetActionButton, GetImageActionButton} from "src/js/utils/ActivityHelper";
import {SpaceNormal} from "src/res/Spacing";
import {
  ColorFieldBorderHover,
  ColorFieldBorderSelected,
  ColorNegative,
  ColorSubTitle,
  ColorTheme,
  ColorTitle,
  ColorWhite
} from "src/styles/Colors";
import TextView from "src/js/components/commons/TextView";
import {GameTextField} from "src/js/components/commons/GameTextField";
import {AppIcon, IconCross} from "src/js/components/commons/AppIcon";
import DialogView from "src/js/components/commons/DialogView";
import {resetUpdateMobileErrMsg, updateContactMobile} from "src/js/actions/profileActions";
import Select from "@material-ui/core/Select";
import {map} from "lodash";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

const useStyles = () => ({
  viewGenderWrapper: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    // backgroundColor: ColorFieldBgWhite,
    // border: '1px solid '+ ColorFieldBorder,
  },
  viewGenderWrapperError: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    // backgroundColor: ColorFieldBgWhite,
    border: '1px solid '+ ColorNegative,
  },
  viewGender: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    // backgroundColor: ColorFieldBgWhite,
    border: '1px solid '+ ColorFieldBorderHover,
    // '&:hover': {
    //   backgroundColor: ColorFieldHover,
    //   border: '1px solid '+ ColorFieldBorderHover,
    // },
  },
  viewGenderSelected: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    border: '2px solid '+ ColorFieldBorderSelected,
    backgroundColor: ColorWhite,
  }
});

const GENDERS_DATA = [
  {id: 1, nameId: 'male'},
  {id: 2, nameId: 'female'},
];

class UpdateMobileInline extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      country: props.app.countries.data[0],
      numberCode: props.app.countries.data[0].numberCode,
      mobileNumber: '',
      name: ''
    };
  }

  componentDidMount() {
    // const {fetchNationalities} = this.props;
    // fetchNationalities();
  }

  render() {
    const {app, classes, title, subTitle, uiConfigs, maxWidth, isXS, isLTR, showNegativeAction, noMinHeight, needName} = this.props;
    const {country, numberCode, mobileNumber, name, showValidationMsg, errorMsg} = this.state;

    uiConfigs.overlayTitleColor = ColorTitle;
    uiConfigs.overlaySubTitleColor = ColorSubTitle;
    uiConfigs.overlayBgColor = ColorWhite;
    uiConfigs.actionBgColor = ColorTheme;
    uiConfigs.actionTitleColor = ColorWhite;

    let mobileNumberError = null;
    let nameError = null;
    if (showValidationMsg) {
      if (!mobileNumber) {
        mobileNumberError = <FormattedMessage id='activity.validationMobileRequired' />;
      }
      if (!name || name.trim().length < 2) {
        nameError = <FormattedMessage id='validation.enterName' />;
      }
    }

    const viewNumberCode = (
      <div style={{width: 90}}>
        <FormControl
          style={{width: '100%'}}
          variant="filled"
          size="small"
          hiddenLabel={true}>
          <Select
            disableUnderline={true}
            labelId="selectLabelId"
            id="numberCode"
            name="numberCode"
            value={numberCode}
            onChange={this.onChange}>
            {
              map(app.countries.data, (item) => {
                const name = app.isLTR ? '+'+ item.numberCode : item.numberCode +'+';
                return <MenuItem key={''+ item.id} value={item.numberCode}>{name}</MenuItem>
              })
            }
          </Select>
        </FormControl>
        {mobileNumberError ? <Space horizontal={22} /> : null}
      </div>
    );

    const inputSpace = isXS ? FIELD_SPACE_XS : FIELD_SPACE;
    const closeActionStyle = {position: 'absolute', top: 8};
    if (isLTR) {
      closeActionStyle.left = 8;
    } else {
      closeActionStyle.right = 8;
    }
    return (
      <div className={classes.viewColumnFullWidth} style={{minHeight: noMinHeight ? 0 : 550, marginBottom: 6}}>
        {title || subTitle ?
          <div className={classes.viewColumnFullWidth} style={{justifyContent: 'center', margin: 16, marginBottom: 8}}>
            <Typography style={{fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor, marginBottom: 4}} variant={isXS ? "h6" : "h5"}>
              {title}
            </Typography>
            <TextView variant={isXS ? "caption" : "body2"} align={'center'} color={uiConfigs.overlaySubTitleColor}>
              {subTitle}
            </TextView>
          </div>
          : null
        }

        <form className={classes.viewColumnFullWidth} onKeyDown={this.handleKeyPress} style={{marginTop: 24, maxWidth: FORM_MAX_WIDTH, minWidth: Math.min(window.appWidth - 56, FORM_MAX_WIDTH)}}>

          <GameTextField
            color={uiConfigs.overlayTitleColor}
            bgColor={uiConfigs.overlayBgColor}
            variant="filled"
            fullWidth
            size="small"
            id="mobileNumber"
            name="mobileNumber"
            autoComplete="text"
            label={<FormattedMessage id='activity.mobileNumberWithCode'/>}
            inputProps={{maxLength: 16}}
            value={mobileNumber}
            onChange={this.onChange}
            error={mobileNumberError != null}
            helperText={mobileNumberError}
          />
          <Space horizontal={inputSpace}/>

          {needName ?
            <React.Fragment>
              <GameTextField
                color={uiConfigs.overlayTitleColor}
                bgColor={uiConfigs.overlayBgColor}
                variant="filled"
                fullWidth
                size="small"
                type="name"
                id="name"
                name="name"
                autoComplete="text"
                label={<FormattedMessage id='login.name'/>}
                inputProps={{maxLength: 200}}
                value={name}
                onChange={this.onChange}
                error={nameError != null}
                helperText={nameError}
              />
              <Space horizontal={inputSpace}/>
            </React.Fragment>
            : null
          }

          {/*<div className={classes.flexRow} style={{alignItems: 'flex-end'}}>*/}
          {/*  /!*{app.isLTR ? viewNumberCode : null}*!/*/}
          {/*  /!*{app.isLTR ? <Space vertical={8}/> : null}*!/*/}
          {/*  <div className={classes.flexGrow}>*/}
          {/*    <TextField*/}
          {/*      variant="filled"*/}
          {/*      fullWidth*/}
          {/*      size="small"*/}
          {/*      type="text"*/}
          {/*      id="mobileNumber"*/}
          {/*      name="mobileNumber"*/}
          {/*      autoComplete="mobile"*/}
          {/*      label={this.context.intl.formatMessage({id: 'login.mobileNumber'})}*/}
          {/*      InputProps={{*/}
          {/*        disableUnderline: true*/}
          {/*      }}*/}
          {/*      inputProps={{*/}
          {/*        // maxLength: country.numberLength*/}
          {/*        maxLength: 16*/}
          {/*      }}*/}
          {/*      value={mobileNumber}*/}
          {/*      onChange={this.onChange}*/}
          {/*      error={mobileNumberError}*/}
          {/*      helperText={mobileNumberError}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*  /!*{!app.isLTR ? <Space vertical={8}/> : null}*!/*/}
          {/*  /!*{!app.isLTR ? viewNumberCode : null}*!/*/}
          {/*</div>*/}

          <View className={classes.viewRowFullWidth} style={{justifyContent: 'center'}}>
            {showNegativeAction ? this.actionButton(<FormattedMessage id={'generic.cancel'} />, this.cancelPost, true, {height: 48, flex: 1, marginRight: isLTR ? 16 : 0, marginLeft: isLTR ? 0 : 16}) : null}
            {this.actionButton(<FormattedMessage id={'manage.confirm'} />, this.onSubmitClicked, false, {height: 48, flex: 1})}
          </View>

          {this.renderErrorMessage()}
        </form>

        {this.renderDialogView()}

        {/*{showNegativeAction ?*/}
        {/*  <div style={closeActionStyle}>*/}
        {/*    <IconButton*/}
        {/*      size={'medium'}*/}
        {/*      onClick={this.cancelPost}*/}
        {/*      style={{width: 46, height: 46}}>*/}
        {/*      <AppIcon icon={IconCross} />*/}
        {/*    </IconButton>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}
      </div>
    );
  }

  renderDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={showDialog}
        {...dialogInfo}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog(onDone) {
    this.setState({showDialog: false, dialogInfo: null}, onDone);
  }

  handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      this.onSubmitClicked();
    }
  }

  renderErrorMessage() {
    const {classes, isXS, profile} = this.props;

    let errMsg = null
    if (profile && profile.errMsgChangeMobile) {
      errMsg = profile.errMsgChangeMobile;
    }

    const inputSpace = isXS ? FIELD_SPACE_XS : FIELD_SPACE;
    return errMsg && (
      <div className={classes.viewColumnFullWidth}>
        <Space top={inputSpace}/>
        <div className={classes.viewColumnFullWidth}>
          <Typography align={"center"} variant={isXS ? "body2" : "body1"} style={{color: ColorNegative, fontWeight: FontWeightMedium}}>
            <FormattedMessage id={errMsg} />
          </Typography>
        </div>
        <Space bottom={inputSpace/2}/>
      </div>
    );
  }

  actionButton = (title, onClick, isNegative, style) => {
    const {uiConfigs, maxWidth, isXS} = this.props;
    const sizeFactor = uiConfigs.sizeFactor;
    let buttonWidth = (maxWidth - 2 * uiConfigs.infoViewContentHorizontalMargin * sizeFactor - (!isXS ? 2 * SpaceNormal : 0) - (isXS ? FIELD_SPACE_XS : FIELD_SPACE)) / 2;
    buttonWidth = Math.max(150, buttonWidth) / sizeFactor;
    if (uiConfigs.otherActionImage) {
      return (
        <GetImageActionButton
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
          onClick={onClick}
          title={title}
          width={buttonWidth}
        />
      );
    } else {
      return (
        <GetActionButton
          isNegative={isNegative}
          uiConfigs={uiConfigs}
          onClick={onClick}
          title={title}
          size={'large'}
          style={style}
        />
      );
    }
  };

  updateState(state) {
    state.showValidationMsg = false;
    this.setState(state);
    if (this.props.profile.errMsgChangeMobile) {
      this.props.resetUpdateMobileErrMsg();
    }
  }

  onChange = (event) => {
    // const {app} = this.props;
    // let {country, mobileNumber} = this.state;
    // let newCountry = country;
    // if (event.target.name === 'numberCode') {
    //   app.countries.data.forEach((lCountry) => {
    //     if (lCountry.numberCode === e.target.value) {
    //       newCountry = lCountry;
    //     }
    //   });
    //   if (newCountry.numberCode !== country.numberCode) {
    //     mobileNumber = '';
    //   }
    // }
    this.updateState({
      [event.target.name]: event.target.value,
      // country: newCountry,
      // mobileNumber: mobileNumber,
    });
  };

  cancelPost = () => {
    if (this.props.onDone) {
      this.props.onDone();
    }
  };

  onSubmitClicked = () => {
    const {activityId, activityPostId, onDone} = this.props;
    const {numberCode, mobileNumber, name} = this.state;
    if (!numberCode || !mobileNumber || mobileNumber.trim().length === 0
      || !name || name.trim().length < 2) {
      this.setState({showValidationMsg: true});
      return;
    }

    const data = {
      activityId: this.props.activityId,
      rewardId: this.props.rewardId,
      contactMobileNumber: mobileNumber,
      name: name,
    }

    const onSuccess = (response) => {
      if (onDone) {
        onDone(1);
      }
    };
    const onError = (response) => {
    }
    this.props.updateContactMobile(data).then(onSuccess).catch(onError);
  };

}

UpdateMobileInline.propTypes = {
  classes: PropTypes.object,
  onDone: PropTypes.func,
};

UpdateMobileInline.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    profile: state.admin.profile
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateContactMobile: (data) => dispatch(updateContactMobile(data)),
    resetUpdateMobileErrMsg: () => dispatch(resetUpdateMobileErrMsg()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
  ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
])(UpdateMobileInline)));
